export const BUILDER_EDITOR_HOSTS = ['EDITOR3', 'STUDIO2'];
//# sourceMappingURL=hosts.js.map